/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    transform="scale(Infinity, Infinity)"
    fill="currentColor"
    fillRule="evenodd"
    d="M13.7143.3288c0 5.6287-4.326 10.1917-9.6623 10.1917a9.2222 9.2222 0 0 1-.3117-.0052v.3392a9.4924 9.4924 0 0 1 .3116-.0052c5.3364 0 9.6624 4.563 9.6624 10.1918 0 .11-.0017.2196-.0049.3288h.3215a10.885 10.885 0 0 1-.0049-.3288c0-5.6288 4.326-10.1918 9.6623-10.1918.1043 0 .2082.0018.3117.0052v-.3392a9.2224 9.2224 0 0 1-.3117.0052c-5.3363 0-9.6623-4.563-9.6623-10.1917 0-.11.0016-.2196.0049-.3288h-.3215c.0032.1092.0049.2188.0049.3288ZM5.5433 14.936c0 2.4247-1.8636 4.3903-4.1623 4.3903-.045 0-.0897-.0007-.1342-.0022v.1461a3.9922 3.9922 0 0 1 .1342-.0022c2.2987 0 4.1622 1.9656 4.1622 4.3903 0 .0474-.0007.0946-.002.1416h.1384a4.7219 4.7219 0 0 1-.002-.1416c0-2.4247 1.8634-4.3903 4.1622-4.3903.0449 0 .0896.0007.1342.0022v-.1461a3.994 3.994 0 0 1-.1342.0022c-2.2988 0-4.1623-1.9656-4.1623-4.3903 0-.0473.0007-.0946.0021-.1416h-.1385c.0014.047.0021.0943.0021.1416Zm-5.5001-.3287c.7388 0 1.3378-.6318 1.3378-1.4112a1.496 1.496 0 0 0-.0007-.0455h.0445a1.529 1.529 0 0 0-.0006.0455c0 .7794.599 1.4112 1.3378 1.4112.0145 0 .0289-.0003.0432-.0007v.0469a1.238 1.238 0 0 0-.0432-.0007c-.7389 0-1.3378.6318-1.3378 1.4112 0 .0152.0002.0304.0007.0455h-.0446a1.496 1.496 0 0 0 .0007-.0455c0-.7794-.599-1.4112-1.3378-1.4112-.0145 0-.0289.0002-.0432.0007v-.0469c.0143.0004.0287.0007.0432.0007Z"
    clipRule="evenodd"
  />,
  'GenAI'
);
